<template>
  <div class="qa-editor">
    <!-- 文档基本信息 -->
    <el-form ref="form_doc" :model="form_doc" :rules="rules_doc" label-width="140px">
      <el-row :gutter="10" class="mb8" v-if="currentDocId==0">              
        <el-col :span="12">
          <el-form-item label="文档标题：" prop="title">
            <el-input v-model="form_doc.title" placeholder="请输入文档标题" />
          </el-form-item>
        </el-col>   
        <el-col :span="6">
          <el-form-item label="文档所在目录：" prop="dirId">
            <el-select v-model="form_doc.dirId" style="width: 100%;" @change="handleSelectDir">
              <el-option 
                v-for="dir in dirs" 
                :key="dir.id" 
                :label="dir.name" 
                :value="dir.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">                    
          <el-button type="primary" size="small" style="margin-top: 0;margin-left: 5px;" @click="submitForm_doc">
            保存文档信息
          </el-button>
        </el-col>          
      </el-row>                      
      <el-row :gutter="10" class="mb8"  style="height:30px;line-height: 30px;" v-else>              
        <el-col :span="12">
          <el-form-item label="文档标题：" prop="title">
            <el-input v-model="form_doc.title" placeholder="请输入文档标题"  />
          </el-form-item>
        </el-col>   
        <el-col :span="6">
          <el-form-item label="文档所在目录：" prop="dirId">
            <el-select v-model="form_doc.dirId" style="width: 100%; height: 800px;" @change="handleSelectDir" disabled>
              <el-option 
                v-for="dir in dirs" 
                :key="dir.id" 
                :label="dir.name" 
                :value="dir.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">                    
          <el-button type="primary" size="small" style="margin-top: 0;margin-left: 5px;" @click="submitForm_doc">
            保存文档信息
          </el-button>
        </el-col>          
      </el-row>   
      <!-- 问答对管理区域 -->
      <el-row :gutter="10" class="mb8" v-if="currentDocId > 0">                 
        <el-col :span="24">
          <div class="qa-section">
            <div class="qa-section-header">
              <h4>问答对列表（共 {{ qaPairs.length }} 条）</h4>
              <el-button type="primary" size="small" @click="addQA">+ 添加问答对</el-button>
            </div>
            
            <!-- 问答对表格 -->
<div class="custom-table" v-if="qaPairs.length > 0">
  <!-- 表头 -->
  <div class="custom-table-header">
    <div class="custom-cell" style="width: 60px;">序号</div>
    <div class="custom-cell" style="flex: 1;">问题</div>
    <div class="custom-cell" style="flex: 1.2;">答案</div>
    <div class="custom-cell" style="flex: 1.2;">是否在文档库中</div>
        <div class="custom-cell" style="flex: 1.2;">是否在主知识库中</div>
    <div class="custom-cell" style="width: 160px;text-align: center; overflow: visible; white-space: normal; padding: 8px 4px;">操作</div>
  </div>
<!-- 数据行 -->
<div class="custom-table-row" v-for="(item, index) in qaPairs" :key="index">
  <div class="custom-cell" style="width: 60px; text-align: center;">{{ index + 1 }}</div>
  <div class="custom-cell" style="flex: 1;" :title="item.question">{{ item.question }}</div>
  <div class="custom-cell" style="flex: 1.2;" :title="item.answer">{{ item.answer }}</div>
    <div class="custom-cell" style="flex: 1.2;width: 100%; text-align: center;" :title="item.anwser" >{{ item.isInDocumentLibrary?'是':'否' }}</div>
      <div class="custom-cell" style="flex: 1.2; width: 100%; text-align: center;" :title="item.anwser">{{ item.isInWorkspace?'是':'否' }}</div>
  <div class="custom-cell" style="width: 240px; text-align: center; display: flex; justify-content: center; align-items: center; gap: 8px; position: relative; z-index: 1;">
    <button class="custom-action-btn edit-btn"   @click.stop.prevent="editQA(item, index)">编辑</button>
    <button 
  class="custom-action-btn delete-btn" 
  type="button"
  @click.stop.prevent="deleteQA(index)"
>
  删除
</button>
    <button class="custom-action-btn embed-btn"   @click.stop.prevent="embedQA(item, index)">嵌入知识库</button>
  </div>
</div>
  </div>          
            <!-- 空状态 -->
            <div v-else class="qa-empty">
              <el-empty description="暂无问答对" :image-size="80">
                <el-button type="primary" size="small" @click="addQA">添加第一条问答对</el-button>
              </el-empty>
            </div>
          </div>
        </el-col>          
      </el-row>
      
      <!-- 未保存文档时的提示 -->
      <el-row v-else :gutter="10" class="mb8">
        <el-col :span="24">
          <el-alert
            title="请先保存文档基本信息，然后才能添加问答对"
            type="info"
            show-icon
            :closable="false"
          ></el-alert>
        </el-col>
      </el-row>
    </el-form>

    <!-- 问答对编辑对话框 -->
    <el-dialog 
      :title="qaDialogTitle" 
      :visible.sync="showQADialog" 
      width="650px" 
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form ref="form_qa" :model="form_qa" :rules="rules_qa" label-width="100px">
        <!-- 隐藏的 id 字段 -->
        <el-form-item prop="id" v-show="true">
          <el-input v-model.number="form_qa.id" type="hidden"></el-input>
        </el-form-item>
        
        <!-- 序号字段（自动生成 -->
        <el-form-item label="编号：" prop="no">
          <el-input v-model.number="form_qa.no" disabled></el-input>
        </el-form-item>
        
        <el-form-item label="问题：" prop="question">
          <el-input 
            v-model="form_qa.question" 
            type="textarea" 
            :rows="3" 
            placeholder="请输入问题内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="答案：" prop="anwser">
          <el-input 
            v-model="form_qa.anwser" 
            type="textarea" 
            :rows="5" 
            placeholder="请输入答案内容"
          ></el-input>
        </el-form-item>
 
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveQA" :loading="qaSubmitting">确认</el-button>
      </span>
    </el-dialog>

    <!-- 嵌入问答对对话框 -->
    <el-dialog 
      :title="embed_qaitem_DialogTitle" 
      :visible.sync="show_embed_qaiem_dialog" 
      width="1024px" 
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form ref="form_qa" :model="form_qa_embed" :rules="rules_qa" label-width="120px">
        <!-- 选择嵌入的工作区 -->
        <el-form-item  label="嵌入的知识库："  prop="target_workspace_slug" v-show="true">
           <el-select v-model="selectedWorkspaceSlug" placeholder="请选择目标知识库" style="width: 100%;">
        <el-option
          v-for="ws in workspaceList"
          :key="ws.slug"
          :label="ws.name"
          :value="ws.slug">
        </el-option>
      </el-select>
            <!-- 隐藏的 id 字段 -->
         <el-input v-model.number="form_qa_embed.id" type="hidden"></el-input>
        </el-form-item>

        
        <!-- 序号字段（自动生成 -->
        <el-form-item label="编号：" prop="no">
          <el-input v-model.number="form_qa_embed.no" disabled></el-input>
        </el-form-item>
        
        <el-form-item label="问题：" prop="question">
          <el-input 
            v-model="form_qa_embed.question" 
            type="textarea" 
            :rows="3" 
            placeholder="请输入问题内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="答案：" prop="anwser">
          <el-input 
            v-model="form_qa_embed.anwser" 
            type="textarea" 
            :rows="5" 
            placeholder="请输入答案内容"
          ></el-input>
        </el-form-item>
 
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="embedQA_submit" :loading="qaSubmitting">确认</el-button>
      </span>
    </el-dialog>    
  </div>
</template>

<script>
import { 
  createOrUpdateQADocument//, 
  //getQADocumentDetail
} from '@/api/aics/KbDocument'
import { getQADocumentDetail,save_qa_items, embed_qa_items, deleteQaitem, list_qa_items } from '@/api/aics/kbDocQaitems'
import { listKbWorkspaces_by_tenantId } from '@/api/aics/kbWorkspace';

export default {
  name: 'QAeditor',
  props: {
    docId: {
      type: Number,
      default: 0
    },
    doctitle: {
      type: String,
      default: ''
    },
    dirs: {
      type: Array,
      default: () => []
    },
    defaultDirId: {
      type: Number,
      default: null
    },
    workspace_slug: {
      type: String,
      default: ''
    },
    tenantId: {
      type: [String, Number],
      default: ''
    },
    username: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableKey: 0,
      currentDocId: 0,
      form_doc: {
        title: '',
        dirId: null
      },
      rules_doc: {
        title: [
          { required: true, message: '请输入文档标题', trigger: 'blur' },
          { min: 1, max: 200, message: '标题长度在1-200个字符', trigger: 'blur' }
        ],
        dirId: [
          { required: true, message: '请选择文档目录', trigger: 'change' }
        ]
      },
      qaPairs: [],
      showQADialog: false,
      isEditingQA: false,
      editingQAIndex: -1,
      qaSubmitting: false,
      form_qa: {
        id: null,
        no: null,
        question: '',
        anwser: '',
        //tags: [],
        //tagInput: '',
        //priority: 'medium',
        
      },
      rules_qa: {
        question: [
          { required: true, message: '请输入问题', trigger: 'blur' },
          { min: 1, max: 500, message: '问题长度在1-500个字符', trigger: 'blur' }
        ],
        anwser: [
          { required: true, message: '请输入答案', trigger: 'blur' },
          { min: 1, max: 2000, message: '答案长度在1-2000个字符', trigger: 'blur' }
        ]
      },
      form_qa_embed: {
        target_workspace_slug:null,
        id: null,
        no: null,
        question: '',
        anwser: '',
        //tags: [],
        //tagInput: '',
        //priority: 'medium',
        
      },
      rules_qa_embed: {
        target_workspace_slug: [
          { required: true, message: '请选择嵌入问答对的知识库', trigger: 'blur' }
        ],        
        question: [
          { required: true, message: '请输入问题', trigger: 'blur' },
          { min: 1, max: 500, message: '问题长度在1-500个字符', trigger: 'blur' }
        ],
        anwser: [
          { required: true, message: '请输入答案', trigger: 'blur' },
          { min: 1, max: 2000, message: '答案长度在1-2000个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      docSubmitting: false,

      embed_qaitem_DialogTitle: '嵌入知识库',
      show_embed_qaiem_dialog : false,
      workspaceList: [],// 嵌入的工作区列表
      selectedWorkspaceSlug: '',// 选择的工作区
    }
  },
  computed: {
    qaDialogTitle() {
      return this.isEditingQA ? '编辑问答对' : '添加问答对'
    }
  },
  watch: {
    docId: {
      handler(newVal) {
        if (newVal && newVal > 0) {
          this.loadDocumentData(newVal)
        } else {
          this.resetForm()
        }
      },
      immediate: true
    },
    doctitle: {
      handler(newVal) {
        if (newVal) {
          this.form_doc.title = newVal
        }
      },
      immediate: true
    },
    defaultDirId: {
      handler(newVal) {
        if (newVal) {
          this.form_doc.dirId = newVal
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.currentDocId = this.docId
    console.log("currentDocId", this.currentDocId)
    this.loadWorkspaceList();
  },
  methods: {
  onTableScroll() {
    // 强制刷新固定列
    if (this.$refs.tableRef) {
      this.$refs.tableRef.doLayout()
    }
  },
    // 加载工作区列表（用于嵌入）
    async loadWorkspaceList() {
      try {
        const res = await listKbWorkspaces_by_tenantId(this.tenantId);
        console.log("listKbWorkspaces_by_tenantId", res);
        this.workspaceList = res?.data || [];
        console.log("  this.workspaceList",   this.workspaceList);
        // 如果有知识库，设置第一个为默认选中
        if (this.workspaceList.length > 0) {
          this.defaultWorkspaceSlug = this.workspaceList[0].slug;
          this.selectedWorkspaceSlug = this.defaultWorkspaceSlug;  // 设置当前选中
        }        
        console.log("this.defaultWorkspaceSlug", this.defaultWorkspaceSlug);
        console.log("this.selectedWorkspaceSlug", this.selectedWorkspaceSlug);
      } catch (error) {
        console.error('加载工作区列表失败:', error);
      }
    },  
  
async loadDocumentData(docId) {
  this.loading = true
  try {
    // 1. 加载文档基本信息
    const docRes = await getQADocumentDetail(docId)
    console.log("getQADocumentDetail", docRes)
    if (docRes.code === 200 && docRes.data) {
      const doc = docRes.data
      this.form_doc.title = doc.title || ''
      this.form_doc.dirId = doc.dir_id || this.defaultDirId
    }
    console.log("this.form_doc", this.form_doc);
    
    // 2. 加载问答对列表
    await this.loadQAPairs()
    
  } catch (error) {
    console.error('加载文档数据失败:', error)
    this.$message.error('加载文档数据失败')
  } finally {
    this.loading = false
  }
},

// 新增：加载问答对列表
async loadQAPairs() {  
  console.log("loadQAPairs", this.currentDocId)
  this.tableKey++;
  try {
    const res = await list_qa_items(this.currentDocId, '', 1, 9999)
    console.log("list_qa_items response:", res)
    if (res && res.data.code === 200) {
      // 根据后端分页返回结构调整
      this.qaPairs =res.data.data.list || [];
      console.log("this.qaPairs",  this.qaPairs)
    } else {
      console.error('加载问答对列表失败:', res?.message)
    }
     // 强制表格重新渲染
     await this.$nextTick()
     this.$refs.tableRef?.doLayout()      
  } catch (error) {
    console.error('加载问答对列表失败:', error)
  }

},
    handleTableScroll() {
      // 每次滚动都强制刷新固定列
      this.$nextTick(() => {
        if (this.$refs.tableRef) {
          this.$refs.tableRef.doLayout()
        }
      })
    },
    resetForm() {
      this.form_doc = {
        title: this.doctitle || '',
        dirId: this.defaultDirId
      }
      this.qaPairs = []
      if (this.$refs.form_doc) {
        this.$refs.form_doc.clearValidate()
      }
    },

    handleSelectDir(value) {
      console.log('选择的目录ID:', value)
      this.$emit('dir-change', value)
    },

    submitForm_doc() {
      this.$refs.form_doc.validate(async (valid) => {
        if (valid) {
          this.docSubmitting = true
          try {
            const params = {
              id: this.docId >= 0 ? this.docId : undefined,
              title: this.form_doc.title,
              dir_id: this.form_doc.dirId,
              doc_type: 4
            }
            const res = await createOrUpdateQADocument(params)
            console.log("createOrUpdateQADocument", res)
            
            if (res && res.data.code === 200) {
              const docId = res.data?.data.data || 0
              if (docId) {
                this.currentDocId = docId
                this.$message.success('文档信息保存成功'+this.currentDocId)
                
                if (this.docId === 0) {
                  this.$emit('doc-created', docId)
                }
              } else {
                this.$message.error('保存成功但未获取到文档ID')
              }
            } else {
              this.$message.error(res.data?.message || '保存失败')
            }
          } catch (error) {
            console.error('保存文档失败:', error)
            this.$message.error('保存文档失败')
          } finally {
            this.docSubmitting = false
          }
        } else {
          this.$message.error('请完善文档基本信息')
          return false
        }
      })
    },

    addQA() {
      this.isEditingQA = false
      this.editingQAIndex = -1
      this.form_qa = {
        id: null,
        no: this.qaPairs.length + 1,
        question: '',
        anwser: ''
      
      }
      this.showQADialog = true
    },

    editQA(qaItem, index) {
      console.log("editQA", qaItem, index);
      this.isEditingQA = true
      this.editingQAIndex = index
      this.form_qa = {
        id: qaItem.id || null,
        no: qaItem.no || (index + 1),
        question: qaItem.question || '',
        anwser: qaItem.anwser || qaItem.answer || ''

      }
      this.showQADialog = true
    },
    embedQA(qaItem, index) {
      console.log("embedQA", qaItem, index);
      this.show_embed_qaiem_dialog = true
      this.editingQAIndex = index
      this.form_qa_embed = {
        id: qaItem.id || null,
        no: qaItem.no || (index + 1),
        question: qaItem.question || '',
        anwser: qaItem.anwser || qaItem.answer || ''

      }
    },

    deleteQA(index) {
      const item = this.qaPairs[index]
      
      this.$confirm('确定删除该问答对吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          if (item.id) {
            const res = await deleteQaitem(item.id)
            console.log("deleteQaitem", res);
            if (res && res.data.code !== 200) {
              this.$message.error(res?.message || '删除失败')
              return
            }
          }
          this.qaPairs.splice(index, 1)
          this.$message.success('删除成功')
          this.$emit('qa-changed', this.qaPairs)
        } catch (error) {
          console.error('删除问答对失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
   
    saveQA() {
      this.$refs.form_qa.validate(async (valid) => {
        if (valid) {
          this.qaSubmitting = true
          try {
            const qaData = {
              doc_id: this.currentDocId,
              no: this.form_qa.no,
              question: this.form_qa.question,
              anwser: this.form_qa.anwser,
              tenant_id: this.tenantId
            }
            console.log("saveQA() ", qaData);
            if (this.isEditingQA && this.form_qa.id) {
              qaData.id = this.form_qa.id
            }

            const res = await save_qa_items(qaData)
            console.log("save_qa_items response:", res)

            if (res && res.data.code === 200) {
              const newItem = {
                id: res.data || Date.now(),
                no: this.form_qa.no,
                question: this.form_qa.question,
                anwser: this.form_qa.anwser,
                //tags: [...this.form_qa.tags],
                //priority: this.form_qa.priority
              }

              if (this.isEditingQA) {
                this.$set(this.qaPairs, this.editingQAIndex, newItem)
                this.$message.success('问答对已更新')
              } else {
                this.qaPairs.push(newItem)
                this.$message.success('问答对已添加')
              }
              this.loadQAPairs();  //刷新表格
              this.showQADialog = false
              this.$emit('qa-changed', this.qaPairs)
            } else {
              this.$message.error(res?.message || '保存问答对失败')
            }
          } catch (error) {
            console.error('保存问答对失败:', error)
            this.$message.error('保存问答对失败')
          } finally {
            this.qaSubmitting = false
          }
        } else {
          this.$message.error('请完善问答对信息')
          return false
        }
      })
    },
  // QAeditor.vue 中的 embedQA_submit 方法
embedQA_submit() {
  // 修改这里：this.$refs.form_qa_embed -> this.$refs.form_qa
  console.log("this.form_qa_embed", this.form_qa_embed)
  this.$refs.form_qa.validate(async (valid) => {
    if (valid) {
      this.qaSubmitting = true
      try {
        const qaData = {
          doc_id: this.currentDocId,
          no: this.form_qa_embed.no,
          question: this.form_qa_embed.question,
          anwser: this.form_qa_embed.anwser,
          target_workspace_slug: this.selectedWorkspaceSlug
        }

        if (this.form_qa_embed.id) {
          qaData.id = this.form_qa_embed.id
        }

        const res = await embed_qa_items(qaData)
        console.log("embed_qa_items response:", res)

        if (res && res.data.code === 200) {         
          this.$message.success('嵌入问答对到知识库成功')
          this.loadQAPairs();
          this.show_embed_qaiem_dialog = false;
        } else {         
          this.$message.error(res.data.message || '保存问答对失败')
        }
      } catch (error) {
        console.error('嵌入问答对到知识库失败:', error);
        this.$message.error('嵌入问答对到知识库失败。'+error);
      } finally {
        this.qaSubmitting = false
      }
    } else {
      this.$message.error('请完善信息')
      return false
    }
  })
},
    async refresh(docId) {
      if (docId && docId > 0) {
        await this.loadDocumentData(docId)
      }
    },

    getQAPairs() {
      return [...this.qaPairs]
    }
  }
}
</script>

<style scoped>
.qa-editor {
  padding: 10px 0;
}

.mb8 {
  margin-bottom: 8px;
}

.qa-section {
  margin-top: 16px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 16px;
  background: #fafafa;
}

.qa-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.qa-section-header h4 {
  margin: 0;
  font-size: 15px;
  color: #303133;
  font-weight: 600;
}

.qa-empty {
  text-align: center;
  padding: 30px 0;
}

.cell-text {
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-editor .el-table .el-table__body tr.el-table__row {
  height: 52px !important;
}
/* 强制所有行高度一致 */
.qa-editor .el-table .el-table__body-wrapper .el-table__body tr.el-table__row {
  height: 48px !important;
}

/* 确保操作列单元格内容完整显示 */
.qa-editor .el-table .el-table__body-wrapper .el-table__body td {
  padding: 4px 0 !important;
}
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.action-btn {
  cursor: pointer;
  font-size: 13px;
  padding: 2px 8px;
  border-radius: 3px;
  transition: opacity 0.2s;
  user-select: none;
}

.edit-btn {
  color: #409eff;
  border: 1px solid #409eff;
}

.embed-btn{
  color:  green;
}

.delete-btn {
  color: #ff4d4f;
  border: 1px solid #ff4d4f;
}

.action-btn:hover {
  opacity: 0.7;
}
.custom-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.custom-table-header {
  display: flex;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
  color: #909399;
}

.custom-table-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
}

.custom-table-row:last-child {
  border-bottom: none;
}

.custom-cell {
  padding: 8px 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-action-btn {
  border: 1px solid;
  background: transparent;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 4px;
}

/* 操作列特殊处理 */
.custom-table-row .custom-cell:last-child {
  overflow: visible !important;
  white-space: normal !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 4px;
  position: relative;
  z-index: 10;  
}

.custom-action-btn.edit-btn {
  color: #409eff;
  border-color: #409eff;
}

.custom-action-btn.delete-btn {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

::v-deep .el-button--text {
  color: #409EFF; /* 默认蓝色 */
}

::v-deep .el-button--text.el-button--danger {
  color: #F56C6C; /* 红色 */
}

/* 如果你想给操作列整体加个背景色测试一下是否生效： */
::v-deep .cell {
  background-color: #f0f9ff !important; /* 浅蓝色背景，让你看清边界 */
}
</style>